import { render } from "./TestInstructionsStepSeven.vue?vue&type=template&id=07ccd5e3&scoped=true&ts=true"
import script from "./TestInstructionsStepSeven.vue?vue&type=script&lang=ts"
export * from "./TestInstructionsStepSeven.vue?vue&type=script&lang=ts"

import "./TestInstructionsStepSeven.vue?vue&type=style&index=0&id=07ccd5e3&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ccd5e3"]])

export default __exports__